var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4 11C4 11 8 7 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 7 4 11 4 11ZM4 6C5.10457 6 6 5.10457 6 4C6 2.89543 5.10457 2 4 2C2.89543 2 2 2.89543 2 4C2 5.10457 2.89543 6 4 6Z","fill":"#F7F8FA"}));
}

Location.defaultProps = {"width":"8","height":"11","viewBox":"0 0 8 11","fill":"none"};

module.exports = Location;

Location.default = Location;
